function About() {
  return (
    <div className="py-8 lg:py-12">
      <div className="container-responsive max-w-4xl">
        <h1 className="text-3xl lg:text-4xl 2xl:text-tv-2xl font-bold text-center mb-4">
          About Indian Metro Web
        </h1>
        <p className="text-center text-neutral-dark/70 mb-12">
          Your complete guide to metro rail travel in India
        </p>

        {/* Mission */}
        <div className="card mb-8">
          <h2 className="text-xl font-semibold mb-4">Our Mission</h2>
          <p className="text-neutral-dark/80 leading-relaxed">
            Indian Metro Web provides comprehensive metro rail information for all Indian cities
            with metro services. Our goal is to make metro travel easier by providing accurate
            route planning, fare calculation, and station information - all sourced from
            official metro authority websites.
          </p>
        </div>

        {/* Features */}
        <div className="card mb-8">
          <h2 className="text-xl font-semibold mb-4">Features</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-start gap-3">
              <span className="text-metro-blue text-xl">✓</span>
              <div>
                <h3 className="font-medium">Route Planning</h3>
                <p className="text-sm text-neutral-dark/70">Find shortest path or minimum interchange routes</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-metro-blue text-xl">✓</span>
              <div>
                <h3 className="font-medium">Fare Calculator</h3>
                <p className="text-sm text-neutral-dark/70">Calculate fares with smart card discounts</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-metro-blue text-xl">✓</span>
              <div>
                <h3 className="font-medium">Interactive Maps</h3>
                <p className="text-sm text-neutral-dark/70">SVG-based metro network maps</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-metro-blue text-xl">✓</span>
              <div>
                <h3 className="font-medium">23 Cities</h3>
                <p className="text-sm text-neutral-dark/70">Coverage across all Indian metro networks</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-metro-blue text-xl">✓</span>
              <div>
                <h3 className="font-medium">Nearby Places</h3>
                <p className="text-sm text-neutral-dark/70">Tourist spots, hotels, and bus stops</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="text-metro-blue text-xl">✓</span>
              <div>
                <h3 className="font-medium">Official Data</h3>
                <p className="text-sm text-neutral-dark/70">All data from official metro authorities</p>
              </div>
            </div>
          </div>
        </div>

        {/* Data Sources */}
        <div className="card mb-8">
          <h2 className="text-xl font-semibold mb-4">Data Sources</h2>
          <p className="text-neutral-dark/80 mb-4">
            All metro data is sourced from official metro authority websites. We do not use
            mock data, Wikipedia, or AI-generated content for station information, fares,
            or routes.
          </p>
          <div className="bg-metro-yellow-soft p-4 rounded-lg text-sm">
            <strong>Note:</strong> While we strive to keep data accurate and up-to-date,
            please verify with official sources before travel for the most current information.
          </div>
        </div>

        {/* Supported Cities */}
        <div className="card">
          <h2 className="text-xl font-semibold mb-4">Supported Cities</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
            {[
              'Delhi', 'Mumbai', 'Bangalore', 'Chennai',
              'Kolkata', 'Hyderabad', 'Jaipur', 'Kochi',
              'Lucknow', 'Nagpur', 'Ahmedabad', 'Noida',
              'Kanpur', 'Pune', 'Navi Mumbai', 'Agra',
              'Meerut', 'Indore', 'Patna', 'Bhopal',
              'Varanasi', 'Surat', 'Visakhapatnam'
            ].map((city) => (
              <div key={city} className="px-3 py-2 bg-metro-blue-soft rounded text-sm text-center">
                {city}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
